<script lang="ts">
	import { onDestroy, onMount, tick } from 'svelte';

    import { Font, FontTypes } from '@uikit/font';

    export let shouldRenderByIntersection = false;
    export let classes = '';
    export let text = '';
    export let style = '';
    export let rootMargin = 0;

    let placeholderEl: HTMLElement;
    let isIntersected = false;

    let observer: IntersectionObserver;

    onMount(() => {
        if (placeholderEl && shouldRenderByIntersection) {
            observer = new IntersectionObserver(
                async ([entry]) => {
                    if (entry.isIntersecting) {
                        isIntersected = true;
                        observer.disconnect();
                        await tick();
                    }
                },
                {
                    root: null,
                    rootMargin: `${rootMargin}px`,
                    threshold: 0.1,
                }
            );

            observer.observe(placeholderEl);
        }
    });

    onDestroy(() => {
        observer?.disconnect();
    });
</script>

{#if !isIntersected && shouldRenderByIntersection}
	<div bind:this={placeholderEl} class={classes} {style}>
		{#if text}
            <Font type={FontTypes.Type.body}>{text}</Font>
		{/if}
	</div>
{:else}
	<slot />
{/if}
